import React, { useCallback } from 'react';
import * as slice from "../../store/activityReport/activityReportSlice";
import { useAppDispatch, useAppSelector } from "../../store/hook";
import { activityReportActions } from '../../store/activityReport/activityReportSlice';

export const useActivityReport = () => {
    const dispatch = useAppDispatch();
    return {
        loadReports: useCallback((payload) => {
            dispatch(activityReportActions.loadReports(payload));
        }, [dispatch]),
        setCourses: useCallback((payload) => {
            dispatch(activityReportActions.setCourses(payload));
        }, [dispatch]),
        pushCourses: useCallback((payload) => {
            dispatch(activityReportActions.pushCourses(payload));
        }, [dispatch]),

        reports: useAppSelector(slice.getReports),
        courses: useAppSelector(slice.getCourses),
    }
}